import './BookChartsTierCard.scss'

const BookChartsTierCard = ({ title, iconClasses, type, data }) => {
  return (
    <div className='book-charts-tier-card'>
      <div className='charts-tier-card-header'>
        <i className={iconClasses}></i>
        <h4>{title}</h4>
      </div>
      <ul className='charts-tier-card-content'>
        {type === 'users' &&
          data.map((user, index) => (
            <UserTierItem
              user={user}
              index={index}
              key={user._id}
            />
          ))}

        {type === 'books' &&
          data.map((book, index) => (
            <BookTierItem
              book={book}
              index={index}
              key={book._id}
            />
          ))}
      </ul>
    </div>
  )
}

export default BookChartsTierCard

const UserTierItem = ({ user, index }) => {
  return (
    <li className='tier-item'>
      <div className='user-data-text'>
        <div className='user-data-info'>
          <h5>{user.name}</h5>
          <span className='user-data-type'>{user.type}</span>
        </div>

        <p>
          {user.type === 'Instrutor'
            ? user.institutionName
            : `Turma: ${user.class}`}
        </p>
        <p>{`${user.count} acessos`}</p>
      </div>
      <span className='tier-number'>{`#${index + 1}`}</span>
    </li>
  )
}

const BookTierItem = ({ book, index }) => {
  return (
    <li className='tier-item'>
      <div className='book-data'>
        <img
          src={book.cover}
          alt={book.title}
        />
        <div className='book-data-text'>
          <h5>{book.title}</h5>
          <p>{`${book.count} visualizações`}</p>
        </div>
      </div>{' '}
      <span className='tier-number'>{`#${index + 1}`}</span>
    </li>
  )
}
